import { SNIES } from '../endpoints';
import request from '../request';

export function getSNIESConfig() {
  return request<{ enabled: boolean }>(SNIES.CONFIG);
}
